import { render, staticRenderFns } from "./M2MList.vue?vue&type=template&id=235cf47a&"
import script from "./M2MList.vue?vue&type=script&lang=js&"
export * from "./M2MList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports